module.exports = __webpack_public_path__ + "img/minus_btn.1dc79ed2.png";